<template>
    <div>
        <div v-if="errorMessage.length">
            {{errorMessage}}
        </div>

        <div v-if="loaded">
            <div class="topbar">
                <div class="d-flex align-items-center">
                    <div class="image-block image-block--lg mr-4">
                        <img :src="LogoHelper.getLogo(info.company_logo)" alt="img">
                    </div>
                    <div>
                        <h2 class="heading2">{{ info.company_name }}</h2>
                        <p class="text-big">Posted {{ dateHelper.decodeDate(info.created, ['month-str']) }}</p>
                    </div>
                </div>
            </div>

            <div class="main-inner min-vh-100" v-if="!showApplication">
                <div class="card card--info w-75 mx-auto" v-if="info.company_description.length">
                    <div class="d-flex">
                        <font-awesome-icon class="fa-2x" :icon="['fa', 'info-circle']" />
                        <div class="pl-3">
                            <h4 class="heading4">About {{ info.company_name }}</h4>
                            <div v-html="info.company_description"></div>
                        </div>
                    </div>
                </div>

                <div class="public-content w-75 mx-auto">
                    <h3 class="heading3">{{ info.name }}</h3>

                    <div v-html="info.description">

                    </div>

                    <p v-if="info.categories.length">
                        <b>Categories:</b>
                        {{ info.categories.join(', ') }}
                    </p>
                    <p v-if="info.start_date && info.end_date">
                        <b>Timeline:</b> {{ dateHelper.decodeDate(info.start_date, ['month-str']) }} - {{ dateHelper.decodeDate(info.end_date, ['month-str']) }}
                    </p>

                    <template v-if="info.submitter_fields.length">
                        <h5 class="heading5 heading5--secondary mr-4 mb-0">Tracker Details</h5>

                        <div v-for="(field, index) in info.submitter_fields" :key="index" class="mb-4">
                            <h5 class="heading5 heading5--secondary">{{field.field.name}}</h5>

                            <custom-field
                                :field="field.field"
                                :value="field.value"
                                :editable="false"
                                :disabled="true"
                            >
                            </custom-field>
                        </div>
                    </template>

                    <template v-if="applicationStatus == 'applied'">
                        <div class="confirmation-send">Your application has been sent</div>
                        
                    </template>
                    
                    
                    <div v-else class="text-center pt-3">
                        <a @click="apply" class="btn btn-primary btn-lg">Apply</a>
                    </div>
                </div>
            </div>

            <template v-else>
                <div class="main-inner min-vh-100">
                    <div class="w-50 mx-auto">
                        <table class="details-table details-table--block m-0 w-100">
                            <tr v-for="(question, index) in questions" :key="index">
                                <td colspan="2" v-if="question.field.type == 'static_text'">
                                    {{question.field.name}}
                                </td>
                                <td v-else>
                                    {{question.field.name}}
                                </td>
        
                                <td v-if="question.field.type != 'static_text'">
                                    <custom-field
                                        :field="question.field"
                                        :value="question.value"
                                        :index="index"
                                        :inline="false"
                                        :instantUpdate="false"
                                        v-on:customValueChanged="answerChanged"
                                    >
                                    </custom-field>
                                </td>
                            </tr>
                        </table>
                        
                        <template v-if="info.has_terms">
                            <div class="input-checkbox">
                                <input id="terms-agree" type="checkbox" v-model="agreed">
                                <label for="terms-agree">I have read and agree to the <a @click="showTerms" class="ml-1">Terms & Conditions</a></label>
                            </div>
                        </template>
                        
                        <div class="text-center pt-3">
                            <button @click="sendApplication" class="btn btn-primary btn-lg" :disabled="info.has_terms && !agreed">Submit Application</button>
                        </div>
                    
                    </div>

                
                </div>
                
            </template>

            <b-modal id="modal-form" :hide-footer="true" modal-class="modal-w-md" title="">
                <template #modal-title>
                    <div v-if="modalAction == 'signup' && registerStatus != 'registered'" >
                        <div class="modal-top">
                            <h2 class="heading2 mb-0">Sign Up to SwitchPitch</h2>
                        </div>
                        <p class="mb-0 mt-3">Have an account? <a @click="modalAction = 'login'" class="link">Log In</a></p>

                    </div>
                    <div v-if="modalAction == 'login'">
                        <div class="modal-top">
                            <h2 class="heading2 mb-0">Log In to SwitchPitch</h2>
                        </div>
                        <p class="mb-0 mt-3">Need an account? <a @click="modalAction = 'signup'" class="link">Sign Up</a></p>
                    </div>
                    <div v-if="modalAction == 'signup' && registerStatus == 'registered'" class="modal-top">
                        <h2 class="heading2 mb-0">Confirm Email</h2>
                    </div>
                    <div v-if="modalAction == 'terms'" class="modal-top">
                        <h2 class="heading2 mb-0">Terms and Conditions</h2>
                    </div>
                </template>

                <template v-if="modalAction == 'signup'">

                    <template v-if="registerStatus != 'registered'">
                        <Signup
                            init-company-type="startup"
                            :publicTrackerId="id"
                            v-on:registered="registered"
                        >
                        </Signup>
                    </template>

                    <div v-else>
                        <div class="form form--enter">
                            <div class="form--enter__container mt-2">
                                <div class="form--enter__fieldset">
                                  <p>We sent an email to {{ registerEmail }} to activate your account. Click the link to complete registration.</p>
                                    <p>If you don’t receive the email, check your spam folder.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>

                
                <template v-if="modalAction == 'login'">
                    <Login
                        :from-tracker="id"
                        v-on:login="login">
                    </Login>
                </template>

                <template v-if="modalAction == 'terms'">
                    <div v-html="info.terms">

                    </div>
                </template>
            </b-modal>

            <b-modal id="profile-form" :hide-footer="true" modal-class="modal-w-lg" title="Complete Your Company Profile">
                <template>
                    <ProfileInfoForm
                        v-on:saved="$bvModal.hide('profile-form'); apply()">
                    </ProfileInfoForm>
                </template>

            </b-modal>


        </div>
    </div>
</template>

<script>
import publicTrackers from "@/services/public-trackers.service"
import profile from "@/services/startup/profile.service"
import Signup from "@/components/common/Signup";
import Login from "@/components/common/Login";
import ProfileInfoForm from "@/components/startup/Profile";
import customField from "@/components/customFields/CustomField";
import trackers from "@/services/startup/trackers.service";

export default {
    components: {
        Signup,
        Login,
        ProfileInfoForm,
        customField,
    },

    data() {
        return {
            id: this.$route.params.id, //Do not parse this to integer, because it can be referral link
            loaded: false,
            errorMessage: "",

            info: {
                company_name: '',
                company_logo: '',
                company_description: '',
                name: '',
                description: '',
                created: "",
                start_date: "",
                end_date: "",
                categories: [],
                need_complete_profile: true,
                has_terms: false,
                terms: "",
            },

            showApplication: false,
            questions: [],
            agreed: 0,

            registerStatus: "new",
            registerEmail: "new",

            modalAction: "signup",
            applicationStatus: "",
            modalWasOpened: false,
            questionFilesNumber : 0,
            loggedIn: false,
        }
    },

    mounted() {

        this.$store.watch(state => {

            if (this.$store.getters.isLoggedIn) {
                if (state.user.company_type) {
                    if (state.user.company_type == 'enterprise') {
                        this.$store.commit('setPageNotFound', true)
                        return
                    } else {
                        if (!this.loggedIn) {
                            this.loggedIn = true
                            this.getInfo()
                            this.checkApplicationStatus()
                        }
                    }
                }
            }
            else {
                if (!this.loaded) {
                    this.getInfo()
                }
            }

            if (this.$route.query['show-login'] && !this.modalWasOpened) {
                this.$root.$on('bv::modal::show', () => {
                    this.modalWasOpened = true
                })
            }
        })
    },

    updated() {
        if (this.$route.query['show-login'] && !this.modalWasOpened) {
            this.modalAction = 'login'
            this.$bvModal.show('modal-form')
        }
    },

    methods: {
        getInfo() {
            let service

            if (this.$store.getters.isLoggedIn) {
                service = trackers
            }
            else {
                service = publicTrackers
            }

            service.getInfo(this.id).then(response => {
                this.info = response.data
                document.title = this.info.name + ' | SwitchPitch'
                this.loaded = true
            }).catch(error => {
                this.errorMessage = error.response.data.message
            })
        },

        checkApplicationStatus() {
            trackers.checkApplicationStatus(this.id).then(response => {
                this.applicationStatus = response.data
            })
        },

        apply() {
            if (this.$store.getters.isLoggedIn) {
                if (this.info.need_complete_profile) {
                    profile.profileComplete().then(response => {
                        if (!response.data) {
                            this.$bvModal.show('profile-form')
                        } else {
                            this.showApplicationData()
                        }
                    })
                } else {
                    this.showApplicationData()
                }
            }
            else {
                this.$bvModal.show('modal-form')
            }
        },

        showApplicationData() {
            this.showApplication = true
            trackers.getQuestions(this.id).then((response) => {
                this.questions = response.data
            })
        },

        registered({status, email}) {
            this.registerStatus = status
            this.registerEmail = email
        },

        answerChanged({index, value}) {
            this.questions[index].value = value

            if (this.questions[index].field.type == 'date') {
                this.questions[index].value.value = this.dateHelper.decodeDate(this.questions[index].value.value)
            }
        },

        sendApplication() {
            trackers.apply(this.id, {answers: this.questions}).then(() => {

                this.questionFilesNumber = this.fileHelper.fieldsWithNewFilesNumber(this.questions)

                if (this.questionFilesNumber) {
                    this.questions.forEach(field => {

                        let formData = new FormData();
                        let hasFiles = false

                        field.value.files.forEach(file => {
                            formData.append('file[]', file)
                            hasFiles = true
                        })

                        if (hasFiles) {
                            trackers.saveFiles(this.id, field.field.id, formData).then(() => {
                                this.questionFilesSaved()
                            })
                        }
                    })
                }

                else {
                    this.applicationStatus = "applied"
                    this.showApplication = false
                }
            })
        },

        questionFilesSaved() {
            --this.questionFilesNumber

            if (!this.questionFilesNumber) {
                this.applicationStatus = "applied"
                this.showApplication = false
            }
        },

        login(params) {
            this.$bvModal.hide('modal-form')

            if (this.$route.query['show-login']) {
                this.$router.push('/public-trackers/' + this.id)
            }

            this.checkApplicationStatus()

            if (params.showProfile) {
                this.$emit('showProfile')
            }
        },

        showTerms() {
            this.modalAction = "terms"
            this.$bvModal.show('modal-form')
        }
    }
}
</script>

<style scoped>

</style>